/**
 * @generated SignedSource<<d3479a1f0022651aa01c25656a9098a8>>
 * @relayHash 2ba830b428a4d9aeab607ff7cc4d0eb9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7ce45398dd83e5e61497fa680ce09200d5e380a7e31060999df6e1ff54417fc1

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type ReportsOverviewPageQuery$variables = {
  avpProjectKey: string;
  boardId: string;
  cloudId: string;
  isBoardContext: boolean;
  isMigrateTMPReportsOverviewEnabled: boolean;
  isSunsetHideEnabled: boolean;
  projectKey: string;
  workspaceAri?: string | null;
};
export type ReportsOverviewPageQuery$data = {
  readonly jira: {
    readonly spaceDashboardAvpProject: {
      readonly projectId: string | null;
    } | null;
  } | null;
  readonly jira_projectByIdOrKey?: {
    readonly projectStyle: JiraProjectStyle | null;
    readonly projectType: JiraProjectType;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ReportCategories" | "SpaceDashboard_spaceDashboardQuery">;
};
export type ReportsOverviewPageQuery = {
  response: ReportsOverviewPageQuery$data;
  variables: ReportsOverviewPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "avpProjectKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "boardId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isBoardContext"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isMigrateTMPReportsOverviewEnabled"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSunsetHideEnabled"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceAri"
},
v8 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v9 = [
  (v8/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "avpProjectKey"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v11 = [
  (v8/*: any*/),
  {
    "kind": "Variable",
    "name": "idOrKey",
    "variableName": "projectKey"
  }
],
v12 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v13 = {
  "kind": "ScalarField",
  "name": "projectStyle"
},
v14 = {
  "kind": "ScalarField",
  "name": "id"
},
v15 = {
  "kind": "ScalarField",
  "name": "failureCode"
},
v16 = {
  "kind": "ScalarField",
  "name": "failureType"
},
v17 = {
  "kind": "ScalarField",
  "name": "hasAccess"
},
v18 = {
  "kind": "ScalarField",
  "name": "hasManage"
},
v19 = {
  "kind": "ScalarField",
  "name": "hasWrite"
},
v20 = {
  "kind": "ScalarField",
  "name": "key"
},
v21 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v22 = {
  "concreteType": "AVPPermissionsPropertyEntry",
  "kind": "LinkedField",
  "name": "properties",
  "plural": true,
  "selections": [
    (v20/*: any*/),
    {
      "kind": "LinkedField",
      "name": "value",
      "plural": false,
      "selections": [
        (v21/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "values"
            }
          ],
          "type": "AVPPermissionsPropertyValueList"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "value"
            }
          ],
          "type": "AVPPermissionsPropertyValueString"
        }
      ]
    }
  ]
},
v23 = {
  "kind": "ScalarField",
  "name": "reason"
},
v24 = {
  "kind": "ScalarField",
  "name": "name"
},
v25 = {
  "concreteType": "JiraReportCategoryEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "concreteType": "JiraReportCategoryNode",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v24/*: any*/),
        {
          "concreteType": "JiraReportConnection",
          "kind": "LinkedField",
          "name": "reports",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraReportConnectionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraReport",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v21/*: any*/),
                    (v24/*: any*/),
                    (v20/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "imageUrl"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "description"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "url"
                    },
                    (v14/*: any*/),
                    {
                      "condition": "isMigrateTMPReportsOverviewEnabled",
                      "kind": "Condition",
                      "passingValue": true,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "isNotApplicableReason"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "isNotApplicableDesc"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        (v14/*: any*/)
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ReportsOverviewPageQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "ReportCategories"
      },
      {
        "kind": "FragmentSpread",
        "name": "SpaceDashboard_spaceDashboardQuery"
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "spaceDashboardAvpProject",
            "args": (v9/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v10/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "isBoardContext",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": (v11/*: any*/),
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "jira_projectByIdOrKey",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v12/*: any*/),
                  "action": "THROW"
                },
                (v13/*: any*/)
              ]
            },
            "action": "THROW"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v6/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReportsOverviewPageQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "spaceDashboardAvpProject",
            "args": (v9/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v14/*: any*/)
            ]
          }
        ]
      },
      {
        "args": [
          {
            "fields": [
              (v8/*: any*/),
              {
                "kind": "Variable",
                "name": "workspaceAri",
                "variableName": "workspaceAri"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "AVPPermissionsGetCapabilitiesResponse",
        "kind": "LinkedField",
        "name": "avpPermissions_getCapabilities",
        "plural": false,
        "selections": [
          {
            "concreteType": "AVPPermissionsCapabilityResult",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "capabilityId"
              },
              {
                "concreteType": "AVPPermissionsHasCapabilityResponse",
                "kind": "LinkedField",
                "name": "result",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  {
                    "concreteType": "AVPPermissionsProductCapabilityResult",
                    "kind": "LinkedField",
                    "name": "productResults",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "productId"
                      },
                      {
                        "concreteType": "AVPPermissionsProductCapabilityResponse",
                        "kind": "LinkedField",
                        "name": "result",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v22/*: any*/),
                  (v23/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isBoardContext",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v11/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jira_projectByIdOrKey",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraReportCategoryConnection",
                "kind": "LinkedField",
                "name": "reportCategories",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": true,
                        "selections": [
                          (v21/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "statusCode"
                          }
                        ]
                      }
                    ]
                  },
                  (v25/*: any*/)
                ]
              },
              (v14/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "isBoardContext",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "boardId"
                  }
                ],
                "kind": "LinkedField",
                "name": "jiraBoard",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "JiraReportCategoryConnection",
                        "kind": "LinkedField",
                        "name": "reportCategories",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/)
                        ]
                      }
                    ],
                    "type": "JiraBoard"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v14/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "7ce45398dd83e5e61497fa680ce09200d5e380a7e31060999df6e1ff54417fc1",
    "metadata": {},
    "name": "ReportsOverviewPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f42068c8a966b532f112192add3a5acd";

export default node;
